import React from 'react';
import classNames from 'classnames';
import { TrendingListing } from 'models/Listing';
import { Link } from 'react-router-dom';
import ResolveImage from 'components/ResolveImage';
import utils, { mapValueToMoneyFormat } from 'utils';
import { useTranslation } from 'react-i18next';
import { getImgUrl } from 'components/ResolveImage/utils';
import useLocationMapper from 'router/data/useLocationMapper';
import useShowFieldVisibleInfo from 'hooks/useShowFieldVisibleInfo';

import './TrendingListingCard.styles.scss';

type TrendingListingCardProps = {
  className?: string;
} & TrendingListing;

const TrendingListingCard: React.FC<TrendingListingCardProps> = (props) => {
  const {
    className,
    slugName,
    gallery,
    listingTitle,
    industry,
    location,
    dealLocation,
    type,
    revenue,
    revenueRequiredVisibleInfo,
  } = props;

  const { locationLabelMapper } = useLocationMapper();

  const classes = classNames('trending-listing-card', className);

  const { t } = useTranslation();

  const { isHidden, reasonToHideContent } = useShowFieldVisibleInfo()(
    revenueRequiredVisibleInfo,
  );

  return (
    <Link
      to={utils.composeBusinessUrl(industry, slugName, type)}
      className="trending-listing-card-wrapper"
    >
      <div className={classes}>
        <div>
          <p className="title">{listingTitle}</p>

          <p className="state-industry">
            <span>{locationLabelMapper[location?.state] || dealLocation}</span>
            <span className="industry">{industry}</span>
          </p>

          {!!revenue && (
            <p className="revenue">
              {mapValueToMoneyFormat(revenue)}
              <span>{t('revenue')}</span>
            </p>
          )}

          {!revenue && isHidden && (
            <p className="revenue">
              <span>
                {t('revenue')} - {reasonToHideContent}
              </span>
            </p>
          )}
        </div>

        <ResolveImage
          src={getImgUrl(gallery[0]?.url, '240')}
          alt="Listing"
          shouldLazyLoad={false}
        />
      </div>
    </Link>
  );
};

export default TrendingListingCard;
